import { AppPrice } from '@galaxy/marketplace-apps';
import { EditionIdentifier } from '@galaxy/marketplace-apps/v1';
import { ListAppsAndAddonsActivationsStatusesForBusinessResponseAppsAndAddonsActivationStatusesInterface as ActivationStatusesInterface } from '@vendasta/accounts/legacy';
import { Pricing } from '../../common/table-pricing/interface';

export interface ActivatableItem {
  appId: string;
  requiredAppIds?: string[];
  requiredEditions?: EditionIdentifier[];
  parentAppId?: string;
  billingId?: string;
  name: string;
  icon: string;
  allowMultipleActivations: boolean;
  usesOrderForm: boolean;
  pricing?: Pricing;
  appPrice?: AppPrice;
  restrictedReason?: string;
  activeState?: ActivationStatusesInterface[];
  children?: ActivatableItem[]; // add-ons
  descriptor?: string;
  // TODO This field is a bit of tech debt around single-product center workflows that exist in here
  isActiveAccount?: boolean;
  isTrial?: boolean;
  trialStatus?: ActivationStatus;
  editionData?: EditionData;
  editionId?: string;
  usesCustomPricing?: boolean;
  partnerCurrency?: string;
}

//TODO: extend these edition interfaces as required
export interface EditionData {
  usesEditions: boolean;
  currentlyActiveEditionId?: string;
  editions?: Edition[];
}

export interface Edition {
  appId: string;
  editionId: string;
  editionName: string;
  billingId: string;
  pricing?: Pricing;
}

export interface ProductEdition {
  appId: string;
  editionId: string;
}

export interface ProductEditionName {
  appId: string;
  editionName: string;
}

export interface ProductName {
  appId: string;
  appName: string;
}

export type ProductEditionMap = Map<string, Edition[]>;

export type AppIdToEditionIdToEditionMap = Map<string, Map<string, Edition>>;

export function isValidEditionId(editionId: string): boolean {
  return typeof editionId === 'string';
}

export interface SelectedItem {
  appId: string;
  quantity: number;
  editionId?: string;
}

export interface QuantityEditionIdPair {
  quantity: number;
  editionId?: string;
}

export type SelectedItems = Map<string, QuantityEditionIdPair>;

export interface SelectedItemQueryParams {
  accountGroupId: string;
  appIds: string;
  addonIds: string;
  partnerId: string;
  navigationSource: string;
}

export type SortDirection = 'ASCENDING' | 'DESCENDING';

export interface ProductBoxItems {
  appId: string;
  name: string;
  editionId?: string;
  editionName?: string;
  icon: string;
  count: number;
  status: number;
  descriptor?: string;
  isTrial?: boolean;
  trialStatus?: ActivationStatus;
}

export enum ActivationStatus {
  NOT_SPECIFIED = 0,
  ACTIVATED = 1,
  PENDING = 2,
  CANCELED = 3,
}

export const agid_key = 'accountGroupId';

export interface ActivatablePackage {
  activatableItemCount: ActivatableItemCount[];
  name: string;
  icon: string;
  packageId: string;
  restricted?: boolean;
}

export interface ActivatableItemCount {
  status: ActivationStatus;
  activatableItem: ActivatableItem;
  editionId?: string;
  editionName?: string;
  currentlyActivatedEditionName?: string;
  quantity: number;
  isTrial?: boolean;
  trialStatus?: ActivationStatus;
}

export enum OrderFormType {
  NONE = 0,
  COMMON = 1,
  CUSTOM = 2,
  DYNAMIC = 3,
  ERROR = 4,
}

export const UWM_PID = 'USFS';
